import * as AppData from '../data/App.data';

export const getParentCategoryList = _ => {
    return AppData.getParentCategoryList();
}
export const getCategoryList = parentCode => {
    return AppData.getChildCategoryList();
}